import { Button, Intent } from "@blueprintjs/core";
import { saveAs } from "file-saver";
import { FGSelectInput, FieldGroup, FieldSet, showError } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { CompetitionReportInfoDto, CompetitionRequestApi, FileDownload } from "../../api";
import { SmallFormGenerator } from "../../components";
import { useApiService, useTl } from "../../hooks";
import { useReferential } from "../../hooks/useReferential";
import { ETLCodes } from "../../locales/ETLCodes";
import { b64toBlob } from "../../utils";

export interface ICompetitionReportProps {}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
`;

export const CompetitionReport: React.FunctionComponent<ICompetitionReportProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(CompetitionRequestApi);
  const [saving, setsaving] = React.useState(false);
  const [sections, sLoading] = useReferential((a) => a.getSections(), true);
  const getDoc = React.useCallback(
    async (d: CompetitionReportInfoDto) => {
      try {
        setsaving(true);
        console.log("data", d);
        var file = await api.getCompetitionReport(d);
        if (file?.fileBytes) {
          var blob = b64toBlob(new FileDownload({ base64Content: file.fileBytes, fileName: file.fileName }));
          saveAs(blob, file.fileName);
        }
        setsaving(false);
      } catch {
        showError(t(ETLCodes.Error));
        setsaving(false);
      }
    },
    [api, t]
  );

  return (
    <FieldSet title={t(ETLCodes.CompetitionsWithoutResults)}>
      <SmallFormGenerator
        initialValues={CompetitionReportInfoDto.fromJS({})}
        onSubmit={getDoc}
        editMode={true}
        showDeleteButton={false}
        hideButtons={true}
      >
        <FieldGroup>
          <FGSelectInput name="sectionId" label={t(ETLCodes.SubActivity)} items={sections} loading={sLoading} />
        </FieldGroup>
        <Container>
          <Button
            type={"submit"}
            text={t(ETLCodes.GenerateReport)}
            loading={saving}
            intent={Intent.PRIMARY}
            icon={<i className="far fa-file-excel" />}
          />
        </Container>
      </SmallFormGenerator>
    </FieldSet>
  );
};
